var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2rem",
    height: "2rem",
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_619_26)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_619_26",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_619_26",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_619_26",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADnklEQVR4nO2cW4hNURiAPwy55hYZ8eCalIyXSW6l5BJJKTE1pEhuefDkRZQXyYQ8SblGLnkgohRFhgfk8qBchyZymeQ+LrO0ml+DmWPW2Wtve591/q/+x7PPWt/ZZ629//WvBYqiKIqiKIqiKEVEe6ASOAu8At4AB4EBaTcsJKYCDwHTQjwB+qbdwEKnLVAFNOSQbCQOp93QQqYDcLwVwUbC/hAT025wIdIOOOIo2UjcAUrSbnihsTlPyUZiedoNLyRmOozJueI10CvtDhQCnYFHESUbiZ1pd6IQWOcp2QDfgVFpdyTrTxm1MYg2wIW0O5NlpsUk2UjMS7tDWWVbzKJrZMxX/uJSzKINsFEtN+d5AqI/A4NU9p98SUC0kdd45Tc+JSTayESrCK8TFH1X8yBNXEtQtAGW6C3dyIGERZ9X0Y2sTFj0DRXdyPCERe9S0U34Zu5MjvgGjFTRTWxISHSVSv6TgZLmjFPyC6C7im7O6ZhFV6rklhkXo+TLQBsVnZtzMUj+DpSp5H8zNgbRu1WyG4c8RY9X0W6UAm89RA9S0e6s9hA9W0XnVxoWNat3RT6vODIEeBdR9ma1nB9LPYaQxSo7P456LNCWq2x3egOPI8p+Jk8xiiOjgY8RZd8Geqppdyo8xutqoIvKdmerh+xTuiLuTolsgzMRY59m9dzpJguuUWXvUNnulHo8iRgpcbAbRRUHhgIvPcdsLe91ZIJn7Z4tGe6ht7UbM4B6D9m3gP4RZds9M3ukxu+CpAyC3vM4B/jqIbs2z9d1+y/YLnUjf1/rnvz4wTI3R8ddw9ZpL2rlO+yC70IpZXCZAwYTKIuAHx6yjdypLeWzx8jqej7XqpfrdSVAlsUgu1qGo2HAZGCvZ4FPTai7xSo8h5Gk4qIkyIJinucEmVTYf9t+oA8BMUsWAEwGow5YE9L65vSENyT5xk1gEgG9Qb7JgNRc0SDHFgVxRtQIz0TU/4iaUE4/KwWuZ0Boa5nFYPLZZzMgNFfYs/2CocRzWSzJsBtcg2M+8CEDcn8Pu/MhSMoyNkkuIPAinRMZkHw/9Hz2L2wK9H2Kz9L2LNaiYRhwNQXRWyhC2gGrPHce5BPH5ODboqWfZNqinjDpEnZu6Jh2R7NCOXAmgTF5U7Hfyf/anncyhu3U9vBxPYbIAZv4WQ88yFPwU2At0MnlS5TmFVMrZCyvlhXyOomnUu9hX/enaBmaoiiKoiiKoiiKoigKLfITfKfz4+dwKvgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1229445a53ce9ba52d749fc36b63d2a6.svg";
export { ForwardRef as ReactComponent };